import styled from 'styled-components';

const h3 = styled.div`
  padding-top: 0.5rem;
  font-size: 1rem;
  color: ${ props => !props.invertedColors ? props.theme.colors.primaryText : props.theme.colors.primaryTextInverted };
  font-weight: 300;
`;

export default h3;

